import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render shortlisted section for FAQ Page
 */
const ShortListedSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="shortlisted-section-component"
    >
      <AccordionV2
        testId="shortlisted"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="2. If I am shortlisted, what will I be required to do?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0 pt-6 leading-[1.4]">
          <p>
            Applicants shortlisted for the Emerging Enteprise Award and Emerging
            Enterprise Sustainability Award will undergo a rigorous 2-part
            judging process: Site visits (physical for all Singapore applicants
            and/or virtual site visit for other Asia applicants) as well as live
            judging for applicants to present their business model, products and
            services to our esteemed panel of judges.
          </p>

          <p>
            The carefully selected expert judging panel will review entries
            based on the criteria set within each category, whilst also applying
            3 key principles:
          </p>

          <ul className="mb-6 list-outside list-disc pl-8">
            <li>Results and performance metrics</li>
            <li>
              Measurable evidence of innovation, impact and scalability, with
              demonstrable, long-term commitment to a sustainable transformation
            </li>
            <li>Relevant award category criteria</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ShortListedSection;
